module.exports = __webpack_public_path__ + "5663d102d5c140c588f9524637b925cf.fbx";